import React, { Component } from 'react';
import { getBilldetail, pay, getBilldetailGzh, payGzh, complain, getDeviceListByMac } from "./services";
import {
    Toast,
} from 'antd-mobile';
import './index.scss';
import wx from 'weixin-js-sdk';
import { GetRequest } from "../../utils/util";

var browser = {
    versions: function () {
        var u = navigator.userAgent;
        return {
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
            wx: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
            ali: u.indexOf('AlipayClient') > -1
        };
    }(),
}
// 需求四：仅洗澡(4)、饮水(5)等预扣设备展示「使用设备」；洗衣机等洗烘设备不展示
const USE_DEVICE_BIG_TYPE_IDS = [4, 5];
// consumeChannel=4：集中器澡堂设备，不展示「使用设备」
const CONSUME_CHANNEL_BATHHOUSE = 4;
// 可展示「使用设备」的渠道（不含鸿蒙）；支付宝另需 supportH5UseDevice
const USE_DEVICE_PHONE_SYSTEMS = ['alipay', 'ios', 'android', 'wechat', 'aliot'];
// 与支付宝小程序 openBillDetailH5 / H5_BILL_SUPPORT_USE_DEVICE 契约一致；支付宝无此标记则不展示入口
const SUPPORT_H5_USE_DEVICE = 1;
class Billdetail extends Component {
    ref = React.createRef();
    constructor(props) {
        super(props)
        // 本页打开时的用户上下文（方法传参主来源，避免多端并发写 state 串户）
        this._session = null;
        this._billReqSeq = 0;
        this.state = {
            phoneSystem: null,
            billdetail: {},
            showModal: false,
            btnContent: '--',
            tipContent: '确定',
            pay: false,
            tip: false,
            showModalErr: false,
            errtipContent: "您还未授权，请先去钱包页面授权后，再重新请求代扣",
            sTitle: '',
            isGzh: false,
            orderAppealSwitch: true,
            supportH5UseDevice: 0,

        }
    }
    /** 绑定本次账单页用户上下文，返回快照供接口方法直接传参 */
    bindSession = ( partial = {} ) => {
        this._session = {
            ...(this._session || {}),
            ...partial,
        };
        return this._session;
    }
    /** 取当前会话快照；优先 _session，缺省再回落 state（兼容旧路径） */
    getSession = () => {
        const s = this.state || {};
        const bill = s.billdetail || {};
        const base = this._session || {};
        return {
            projectId: base.projectId != null ? base.projectId : s.projectId,
            accountId: base.accountId != null ? base.accountId : s.accountId,
            orderId: base.orderId != null ? base.orderId : s.orderId,
            token: base.token != null ? base.token : s.token,
            userId: base.userId != null ? base.userId : s.userId,
            consumeDate: base.consumeDate != null ? base.consumeDate : s.consumeDate,
            telephone: base.telephone != null ? base.telephone : s.telephone,
            phoneSystem: base.phoneSystem != null ? base.phoneSystem : s.phoneSystem,
            guardianId: base.guardianId != null ? base.guardianId : s.guardianId,
            orderAppealSwitch: base.orderAppealSwitch != null ? base.orderAppealSwitch : s.orderAppealSwitch,
            // 新版支付宝小程序打开账单会带 supportH5UseDevice=1
            supportH5UseDevice: base.supportH5UseDevice != null ? base.supportH5UseDevice : s.supportH5UseDevice,
            // 账单详情返回后优先用详情里的账户/时间（与当次查单一致）
            billAccountId: bill.accountId,
            billConsumeDate: bill.consumeDate,
            billOrderId: bill.orderId,
            billTelephone: bill.telephone || bill.telPhone || bill.mobile,
        };
    }
    // 中学家长端等 roadcampus 渠道提示「授权页面」，App/微信等提示「钱包页面」
    getAuthTipContent = (phoneSystem) => {
        const system = String(phoneSystem || this.getSession().phoneSystem || '').toLowerCase();
        const isRoadCampus = system.includes('roadcampus');
        const pageName = isRoadCampus ? '授权页面' : '钱包页面';
        return `您还未授权，请先去${pageName}授权后，再重新请求代扣`;
    }
    // 使用设备：微信/App 可展示；鸿蒙、roadcampus 不展示；支付宝需新版标记
    canShowUseDeviceButton = (phoneSystem) => {
        const system = String(phoneSystem || this.getSession().phoneSystem || '').toLowerCase();
        if (!system) return false;
        // 鸿蒙不展示「使用设备」
        if (system.includes('harmony') || system.includes('openharmony')) return false;
        // 中学 roadcampus（如 roadcampus_wechat）不展示「使用设备」
        if (system.includes('roadcampus')) return false;
        const matched = USE_DEVICE_PHONE_SYSTEMS.some(
            (key) => system === key || system.includes(key)
        );
        if (!matched) return false;
        // 支付宝：仅新版小程序带 supportH5UseDevice 时展示（与 MP 常量 H5_BILL_SUPPORT_USE_DEVICE 对齐）
        if (system === 'alipay' || system.includes('alipay')) {
            const flag = this.getSession().supportH5UseDevice;
            return Number(flag) === SUPPORT_H5_USE_DEVICE || flag === true;
        }
        return true;
    }
    parseRouteData = () => {
        const search = window.location.search.startsWith('?')
            ? window.location.search.slice(1)
            : window.location.search;
        if (!search) return null;
        let raw = null;
        // 优先取 data= 后的完整内容，避免 JSON 内含 &/= 时被 GetRequest 截断
        const dataMatch = search.match(/(?:^|&)data=([\s\S]*)/);
        if (dataMatch) {
            raw = dataMatch[1];
            // data 后若还拼了其它顶层参数，只保留到下一个顶层 &key=
            const nextParam = raw.search(/&[a-zA-Z_][a-zA-Z0-9_]*=/);
            if (nextParam !== -1) {
                raw = raw.slice(0, nextParam);
            }
        } else {
            raw = GetRequest().data;
        }
        if (!raw) return null;
        try {
            return JSON.parse(decodeURIComponent(raw));
        } catch (e) {
            try {
                const match = decodeURIComponent(raw).match(/\{[\s\S]*\}/);
                return match ? JSON.parse(match[0]) : null;
            } catch (err) {
                console.error('parse billDetail route data failed', err);
                return null;
            }
        }
    }

    loadBillFromData = (data, fallbackPhoneSystem) => {
        if (!data) {
            Toast.show({ content: '参数异常，无法加载账单' });
            return;
        }
        window.localStorage.setItem('token', data.token);
        const phoneSystem = data.phoneSystem || fallbackPhoneSystem;
        // 家长端：带 GZH / guardianId，无订单申诉功能
        const isGuardian = !!(data.GZH || data.guardianId);
        if (isGuardian) {
            const session = this.bindSession({
                isGzh: true,
                projectId: data.projectId,
                accountId: data.accountId,
                orderId: data.orderId,
                token: data.token,
                guardianId: data.guardianId,
                phoneSystem,
                orderAppealSwitch: false,
            });
            this.setState({
                isGzh: true,
                projectId: session.projectId,
                accountId: session.accountId,
                orderId: session.orderId,
                token: session.token,
                guardianId: session.guardianId,
                phoneSystem: session.phoneSystem,
                orderAppealSwitch: false,
            });
            this.getBilldetailGzhFn(session);
            return;
        }
        const session = this.bindSession({
            isGzh: false,
            projectId: data.projectId,
            accountId: data.accountId,
            orderId: data.orderId,
            token: data.token,
            userId: data.userId,
            consumeDate: data.consumeDate,
            telephone: data.telephone,
            phoneSystem,
            orderAppealSwitch: data.orderAppealSwitch !== undefined
                ? Number(data.orderAppealSwitch)
                : this.state.orderAppealSwitch,
            supportH5UseDevice: data.supportH5UseDevice != null
                ? Number(data.supportH5UseDevice)
                : 0,
        });
        this.setState({
            projectId: session.projectId,
            accountId: session.accountId,
            orderId: session.orderId,
            token: session.token,
            userId: session.userId,
            consumeDate: session.consumeDate,
            telephone: session.telephone,
            phoneSystem: session.phoneSystem,
            orderAppealSwitch: session.orderAppealSwitch,
            supportH5UseDevice: session.supportH5UseDevice,
            isGzh: false,
        });
        this.getBilldetailFn(session);
    }

    initData() {
        const routeData = this.parseRouteData();
        // 有 URL data 一律走参数加载（中学 roadcampus_wechat、微信/支付宝小程序、iOS 等）
        // 避免因 WebView 注入了 window.android 却不调 getParams 导致白屏无数据
        if (routeData) {
            let fallback = routeData.phoneSystem || 'H5';
            if (!routeData.phoneSystem) {
                const ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    fallback = 'WeChat';
                } else if (/Alipay/i.test(navigator.userAgent)) {
                    fallback = 'Alipay';
                } else if (browser.versions.ios) {
                    fallback = 'ios';
                } else if (browser.versions.android) {
                    fallback = 'android';
                }
            }
            this.loadBillFromData(routeData, fallback);
            return;
        }
        // 无 URL 参数时：Android 趣智 App 等 getParams 注入
        if (window.android && typeof window.android === 'object') {
            return;
        }
    }
    loadAlipayMiniProgramBridge = () => {
        if (!/Alipay/i.test(navigator.userAgent)) return Promise.resolve();
        if (window.my && typeof window.my.navigateTo === 'function') return Promise.resolve();
        return new Promise((resolve) => {
            const existing = document.querySelector('script[data-alipay-webview-bridge="1"]');
            if (existing) {
                existing.addEventListener('load', resolve, { once: true });
                existing.addEventListener('error', resolve, { once: true });
                return;
            }
            const script = document.createElement('script');
            script.src = 'https://appx/web-view.min.js';
            script.setAttribute('data-alipay-webview-bridge', '1');
            script.onload = resolve;
            script.onerror = resolve;
            document.head.appendChild(script);
        });
    }
    componentDidMount() {
        document.title = '账单详情';
        window.getParams = this.getParams;
        this.loadAlipayMiniProgramBridge();
        this.initData()
    }
    getParams = (projectId, accountId, orderId, token, userId, consumeDate, orderAppealSwitch) => {
        window.localStorage.setItem('token', token);
        // Android App 通过 getParams 注入；整包写入 session 后按参数查单，不从 state 回读
        const session = this.bindSession({
            projectId,
            accountId,
            orderId,
            token,
            userId,
            consumeDate,
            orderAppealSwitch: parseInt(orderAppealSwitch, 10),
            phoneSystem: 'android',
            isGzh: false,
        });
        this.setState({
            projectId: session.projectId,
            accountId: session.accountId,
            orderId: session.orderId,
            token: session.token,
            userId: session.userId,
            consumeDate: session.consumeDate,
            orderAppealSwitch: session.orderAppealSwitch,
            phoneSystem: 'android',
            isGzh: false,
        });
        this.getBilldetailFn(session);
    }
    getBilldetailGzhFn = (session = {}) => {
        const {
            accountId,
            projectId,
            orderId,
            token,
            guardianId,
            phoneSystem,
        } = session;
        const reqSeq = ++this._billReqSeq;
        const params = {
            accountId,
            loginCode: token,
            guardianId,
            projectId,
            orderId,
            phoneSystem,
        };
        getBilldetailGzh(params).then((res) => {
            if (reqSeq !== this._billReqSeq) return;
            if (res.errorCode == 0) {
                let num = (res.data.consumeDate).replace(/[^0-9]/ig, "");
                res.data.orderNumber = num;
                this.bindSession({
                    accountId: res.data.accountId != null ? res.data.accountId : accountId,
                    consumeDate: res.data.consumeDate || session.consumeDate,
                    orderId: res.data.orderId || orderId,
                    projectId: res.data.projectId != null ? res.data.projectId : projectId,
                });
                this.setState({
                    billdetail: res.data,
                    accountId: this._session.accountId,
                    consumeDate: this._session.consumeDate,
                    orderId: this._session.orderId,
                    projectId: this._session.projectId,
                });
            }
        })
    }
    /** 查账单：只用方法入参 session，不用 this.state 拼 consumeDate/accountId */
    getBilldetailFn = (session = {}) => {
        const {
            accountId,
            projectId,
            orderId,
            token,
            userId,
            consumeDate,
            phoneSystem,
        } = session;
        const reqSeq = ++this._billReqSeq;
        const params = {
            accountId,
            loginCode: token,
            userId,
            projectId,
            orderId,
            phoneSystem,
        };
        if (!orderId && consumeDate) {
            params.consumeDate = consumeDate;
        }
        getBilldetail(params).then((res) => {
            if (reqSeq !== this._billReqSeq) return;
            if (res.errorCode === 0) {
                let num = (res.data.consumeDate).replace(/[^0-9]/ig, "");
                res.data.orderNumber = num;
                // 用接口结果校准 session；telephone 接口空时保留入口 URL/会话手机号，避免使用设备 myInfo 漏号
                const nextTel = res.data.telephone || res.data.telPhone || res.data.mobile
                    || session.telephone || session.billTelephone;
                this.bindSession({
                    accountId: res.data.accountId != null ? res.data.accountId : accountId,
                    consumeDate: res.data.consumeDate || consumeDate,
                    orderId: res.data.orderId || orderId,
                    projectId: res.data.projectId != null ? res.data.projectId : projectId,
                    userId: res.data.userId != null ? res.data.userId : userId,
                    telephone: nextTel,
                });
                this.setState({
                    billdetail: res.data,
                    accountId: this._session.accountId,
                    consumeDate: this._session.consumeDate,
                    orderId: this._session.orderId,
                    projectId: this._session.projectId,
                    userId: this._session.userId,
                    telephone: this._session.telephone,
                });
            } else {
                Toast.show({ content: res.errorMessage || '账单加载失败' });
            }
        }).catch(() => {
            if (reqSeq !== this._billReqSeq) return;
            Toast.show({ content: '账单加载失败' });
        })
    }
    showTip = () => {
        this.setState({
            pay: false,
            tip: true,
            tipContent: "由于现场网络信号不稳或和设备蓝牙连接断开，导致该笔消费数据未结算。您可以尝试通过手机蓝牙再次连接该设备（<span style='color:#FC5A5A'>不需要点击使用</span>）进行自动结算，或者等待设备在线(连接)后自动结算"
            , btnContent: "我知道了"
        }, () => {
            this.setState({ showModal: true })
        })
    }
    gotoPay = () => {
        const { billdetail, } = this.state;
        const { tradeSettlement, deductType, walletConsumeMoney, } = billdetail;
        if (walletConsumeMoney == 0 && tradeSettlement == 0 && deductType == 6) {
            this.PayFn()
            return;
        }
        this.setState({
            tip: false,
            pay: true,
            tipContent: "请先确保代扣已授权，确保代扣账户有足够金额！",
            btnContent: "重新请求代扣"
        }, () => {
            this.setState({ showModal: true })
        })
    }
    PayFn = () => {
        const session = this.getSession();
        const { billdetail } = this.state;
        const { deductType } = billdetail || {};
        const accountId = session.billAccountId != null ? session.billAccountId : session.accountId;
        const consumeDate = session.billConsumeDate || session.consumeDate;
        const orderId = session.billOrderId || session.orderId;
        const telephone = session.billTelephone || session.telephone;
        const phoneSystem = session.phoneSystem || 'WeChat';
        // 必须沿用打开页传入的 phoneSystem（如 roadcampus_wechat），
        // 不能交给 UA 自动识别成 WeChat，否则 loginCode 校验会报登录失效
        let params = {
            deductType,
            consumeDate,
            projectId: session.projectId,
            accountId,
            loginCode: session.token,
            userId: session.userId,
            phoneSystem,
        }
        if (telephone) {
            params.telephone = telephone;
        }
        pay(params).then((res) => {
            if (res.errorCode == 0) {
                const { deductType: dt } = billdetail;
                if (dt == 6) {
                    Toast.show({
                        icon: 'success',
                        content: '支付成功',
                        duration: 1100,
                    })
                } else {
                    Toast.show({
                        icon: 'success',
                        content: '已请求',
                        duration: 1100,
                    })
                }
                setTimeout(() => {
                    this.setState({ showModal: false, showModalErr: false })
                    this.getBilldetailFn({
                        ...session,
                        accountId,
                        orderId,
                        consumeDate,
                        phoneSystem,
                    });
                }, 1000)

            } else if (res.errorCode == 221) {
                this.setState({
                    sTitle: false,
                    errtipContent: this.getAuthTipContent(phoneSystem)
                }, () => {
                    this.setState({ showModalErr: true })
                })
            } else {
                this.setState({
                    sTitle: false,
                    errtipContent: res.errorMessage
                }, () => {
                    this.setState({ showModalErr: true })
                })
            }
        })
    }
    renderModal = () => {
        const { showModal, btnContent, tipContent, tip } = this.state;
        return (
            <>
                {/* 底部透明灰色层  */}
                <div className={showModal ? "mask display2" : "mask"}></div>
                {/* <!-- 提示层 --> */}
                <div className={showModal ? "board display" : "board"}>
                    <div className="titile"><span>提示</span></div>
                    <div className='content mg30' style={{ border: 0 }}>
                        <div className="text-box">
                            <span dangerouslySetInnerHTML={{ __html: tipContent }} className={tip ? "t_value_center left" : "t_value_center"}></span>
                        </div>
                    </div>
                    <div className="modal-btn-box">
                        <span className="towBtn bgb" onClick={() => this.submit()}>{btnContent}</span>
                    </div>
                </div>
            </>
        )
    }
    renderModalErr = () => {
        const { showModalErr, errtipContent, sTitle } = this.state;
        return (
            <>
                {/* 底部透明灰色层  */}
                <div className={showModalErr ? "mask display2" : "mask"}></div>
                {/* <!-- 提示层 --> */}
                <div className={showModalErr ? "board display" : "board"}>
                    <div className="titile"><span>{sTitle || '提示'}</span></div>
                    <div className='content mg30' style={{ border: 0 }}>
                        <div className="text-box">
                            <div dangerouslySetInnerHTML={{ __html: errtipContent }} className={sTitle ? "t_value_center left" : "t_value_center"}></div>
                        </div>
                    </div>
                    <div className="modal-btn-box">
                        <span className="towBtn bgb" onClick={() => this.clickHandler()}>我知道了</span>
                    </div>
                </div>
            </>
        )
    }
    clickHandler = () => {
        this.setState({ showModal: false, showModalErr: false })
    }
    submit = () => {

        const { pay, tip } = this.state
        if (pay) {
            this.PayFn()
        }
        if (tip) {
            this.setState({ showModal: false })
        }
    }
    complainFn = () => {
        if (this._complainLoading) return;
        const session = this.getSession();
        const { billdetail } = this.state;
        const accountId = session.billAccountId != null ? session.billAccountId : session.accountId;
        const consumeDate = (billdetail && billdetail.consumeDate) || session.billConsumeDate || session.consumeDate;
        const telephone = session.billTelephone || session.telephone || (billdetail && billdetail.telephone);
        const phoneSystem = session.phoneSystem;
        console.log(phoneSystem, '点击订单申诉phoneSystem');

        let params = {
            telPhone: telephone,
            dealDate: consumeDate,
            projectId: session.projectId,
            accountId,
            loginCode: session.token,
            userId: session.userId,
            phoneSystem,
        }
        this._complainLoading = true;
        complain(params).then((res) => {
            this._complainLoading = false;
            if (res.errorCode == 0 && Array.isArray(res.data) && res.data.length > 0) {
                res.data.forEach(element => {
                    element.orderNumber = element.dealDate.replace(/[^0-9]/ig, "");
                });
                console.log(res.data);
                // 与 pre 分支保持一致：数组整包传给小程序；description 先 encode，避免 URL 截断
                res.data[0].loginCode = session.token;
                res.data[0].projectId = session.projectId;
                res.data[0].telephone = telephone;
                res.data[0].userId = session.userId;
                res.data[0].accountId = accountId;
                res.data[0].description = encodeURIComponent(res.data[0].description || '');
                res.data[0].deviceDescription = encodeURIComponent(res.data[0].deviceDescription || '');
                this.setState({ complainData: res.data }, () => {
                    this.clickHandlerSkip()
                })
            } else if (res.errorCode == 48) {
                this.setState({ canComplainData: 1 })
            } else {
                Toast.show({ content: (res && res.errorMessage) || '获取申诉订单失败' });
            }
        }).catch(() => {
            this._complainLoading = false;
            Toast.show({ content: '获取申诉订单失败' });
        })
    }
    complaint = () => {
        const { billdetail, canComplainData } = this.state;
        if (billdetail.canComplain == 1) {
            this.setState({
                sTitle: '该订单不可申诉',
                errtipContent: "1、该订单已超过7天，无法申请申诉<br/>2、该订单已提交过申诉（申述处理中或已处理）"
            }, () => {
                this.setState({ showModalErr: true })
            })
            return;
        }
        this.complainFn()
    }
    buildAlipayMyInfoPayload = (devList) => {
        const session = this.getSession();
        const { billdetail } = this.state;
        const accountId = (devList && devList.accountId) != null
            ? devList.accountId
            : (session.billAccountId != null ? session.billAccountId : session.accountId);
        // 与申诉一致：多路兜底，避免账单接口未回 telephone 时漏传
        const tel = session.billTelephone
            || session.telephone
            || (billdetail && (billdetail.telephone || billdetail.telPhone || billdetail.mobile))
            || (devList && (devList.telephone || devList.telPhone));
        return {
            loginCode: session.token || session.loginCode,
            userId: session.userId,
            projectId: (devList && devList.projectId) || session.projectId,
            accountId,
            telephone: tel || '',
        };
    }
    // 仅 UA 含 MiniProgram 才认定在 web-view 内。
    // 注意：openURL 外开也会注入 appx/web-view.min.js（有 my.navigateTo），不能用「有 my」挡 scheme，否则线上/测试外开都会跳不过去。
    isAlipayMiniProgramUa = () => /MiniProgram/i.test(navigator.userAgent || '');
    // true = 容器内跳转且禁 scheme；false = openURL 外开，走 alipays://（现网能通的那条）
    shouldUseAlipayMpNav = (getEnvFlag) => {
        if (getEnvFlag === true) return true;
        if (getEnvFlag === false) return false;
        return this.isAlipayMiniProgramUa();
    };
    canFallbackAlipayScheme = () => !this.shouldUseAlipayMpNav();
    // App 约定平级字段
    buildAppUseDevicePayload = (device, billdetail, accountId, projectId, billSn) => {
        const snCode = device.snCode || billSn;
        const bigTypeId = device.bigTypeId != null ? device.bigTypeId : billdetail.bigTypeId;
        return {
            snCode,
            bigTypeId,
            Dsbtypeid: bigTypeId,
            deviceName: device.deviceName || device.DevName || billdetail.deviceName || billdetail.DevName,
            projectId: device.projectId || projectId,
            accountId,
            smallTypeId: device.smallTypeId != null ? device.smallTypeId : billdetail.smallTypeId,
            bindDeviceSnCode: device.bindDeviceSnCode || billdetail.bindDeviceSnCode,
            communicationTypeId: device.communicationTypeId != null ? device.communicationTypeId : billdetail.communicationTypeId,
            devTypeStatus: device.devTypeStatus != null ? device.devTypeStatus : billdetail.devTypeStatus,
        };
    }
    // 支付宝：接口设备平级整包 + 必要兜底（goShowerSn 吃完整设备字段）
    buildAlipayUseDevicePayload = (device, accountId, projectId, billSn) => {
        const session = this.getSession();
        const { billdetail } = this.state;
        const snCode = device.snCode || device.deviceSncode || billSn;
        const bigTypeId = device.bigTypeId != null ? device.bigTypeId : device.Dsbtypeid;
        const telephone = session.billTelephone
            || session.telephone
            || (billdetail && (billdetail.telephone || billdetail.telPhone || billdetail.mobile))
            || device.telephone
            || device.telPhone
            || '';
        return {
            ...device,
            snCode,
            macAddress: device.macAddress || device.mac || snCode,
            bigTypeId,
            Dsbtypeid: device.Dsbtypeid != null ? device.Dsbtypeid : bigTypeId,
            deviceName: device.deviceName || device.DevName,
            projectId: device.projectId || projectId,
            accountId,
            telephone,
        };
    }
    navigateAlipayUseDevice = (devList, query) => {
        const myInfo = this.buildAlipayMyInfoPayload(devList);
        const myInfoQuery = encodeURIComponent(JSON.stringify(myInfo));
        const status = devList.onlineStatusId != null ? Number(devList.onlineStatusId)
            : (devList.isOnline != null ? Number(devList.isOnline) : 1);
        const isOnline = status === 1;
        const infoQuery = encodeURIComponent(JSON.stringify(devList));
        const targetUrl = isOnline
            ? `/pages/goShowerSn/goShowerSn?devList=${query}&myInfo=${myInfoQuery}`
            : `/pages/begin-shower/begin-shower?info=${infoQuery}&myInfo=${myInfoQuery}`;

        const openByScheme = () => {
            this.openAlipayUseDeviceScheme(devList, query, myInfoQuery, isOnline);
        };
        const failInWebView = () => {
            Toast.show({ content: '跳转下单页失败，请升级小程序后重试' });
        };

        const tryNavigate = (onFail) => {
            if (!window.my || typeof window.my.navigateTo !== 'function') return false;
            window.my.navigateTo({
                url: targetUrl,
                fail: (err) => {
                    console.warn('my.navigateTo useDevice failed', err);
                    if (typeof onFail === 'function') onFail();
                },
            });
            return true;
        };
        const tryRedirect = (onFail) => {
            if (!window.my || typeof window.my.redirectTo !== 'function') return false;
            window.my.redirectTo({
                url: targetUrl,
                fail: (err) => {
                    console.warn('my.redirectTo useDevice failed', err);
                    if (typeof onFail === 'function') onFail();
                },
            });
            return true;
        };
        const tryPostMessageThenBack = () => {
            if (!window.my || typeof window.my.postMessage !== 'function') return false;
            try {
                window.my.postMessage({ action: 'useDevice', devList, myInfo, isOnline });
                if (typeof window.my.navigateBack === 'function') {
                    setTimeout(() => {
                        try { window.my.navigateBack(); } catch (e) { /* ignore */ }
                    }, 50);
                }
                return true;
            } catch (e) {
                return false;
            }
        };

        // web-view 内：容器 API，禁止 scheme（040001011）
        const openInWebView = () => {
            if (tryNavigate(() => {
                if (tryRedirect(() => {
                    if (tryPostMessageThenBack()) return;
                    failInWebView();
                })) return;
                if (tryPostMessageThenBack()) return;
                failInWebView();
            })) return;
            if (tryRedirect(() => {
                if (tryPostMessageThenBack()) return;
                failInWebView();
            })) return;
            if (tryPostMessageThenBack()) return;
            failInWebView();
        };

        const run = (inMp) => {
            if (this.shouldUseAlipayMpNav(inMp)) {
                openInWebView();
                return;
            }
            // openURL 外开：与现网一致走 alipays://
            openByScheme();
        };

        if (this.isAlipayMiniProgramUa()) {
            if (window.my && typeof window.my.getEnv === 'function') {
                let settled = false;
                const finish = (flag) => {
                    if (settled) return;
                    settled = true;
                    run(flag);
                };
                try {
                    window.my.getEnv((res) => finish(!!(res && res.miniprogram)));
                    setTimeout(() => finish(true), 300);
                    return;
                } catch (e) {
                    run(true);
                    return;
                }
            }
            this.loadAlipayMiniProgramBridge().then(() => run(true));
            return;
        }
        // 无 MiniProgram UA → 外开，直接 scheme（不要被 bridge 的 my 误导）
        openByScheme();
    }
    openAlipayUseDeviceScheme = (devList, query, myInfoQuery, isOnline) => {
        let online = isOnline;
        if (online == null) {
            const status = devList.onlineStatusId != null ? Number(devList.onlineStatusId)
                : (devList.isOnline != null ? Number(devList.isOnline) : 1);
            online = status === 1;
        }
        if (online) {
            const infoQuery = myInfoQuery || encodeURIComponent(JSON.stringify(this.buildAlipayMyInfoPayload(devList)));
            const pageQuery = encodeURIComponent(`devList=${query}&myInfo=${infoQuery}`);
            window.location.href = `alipays://platformapi/startapp?appId=2018090661238647&page=pages/goShowerSn/goShowerSn&query=${pageQuery}`;
            return;
        }
        const infoQuery = encodeURIComponent(JSON.stringify(devList));
        const userInfoQuery = myInfoQuery || encodeURIComponent(JSON.stringify(this.buildAlipayMyInfoPayload(devList)));
        const pageQuery = encodeURIComponent(`info=${infoQuery}&myInfo=${userInfoQuery}`);
        window.location.href = `alipays://platformapi/startapp?appId=2018090661238647&page=pages/begin-shower/begin-shower&query=${pageQuery}`;
    }
    // 使用设备：必查设备；支付宝整包设备字段，App 用约定平级字段
    useDevice = () => {
        const session = this.getSession();
        const { billdetail } = this.state;
        const accountId = session.billAccountId != null ? session.billAccountId : session.accountId;
        const projectId = billdetail.projectId || session.projectId;
        const billSn = billdetail.snCode || billdetail.deviceSncode || billdetail.macAddress || billdetail.mac;
        const billDeviceId = billdetail.deviceId != null ? billdetail.deviceId : billdetail.DevID;
        if (!billSn) {
            Toast.show({ content: '缺少设备编号，无法跳转使用页' });
            return;
        }
        getDeviceListByMac({
            macAddressList: String(billSn),
            projectId: String(projectId),
            isNew: 1,
            loginCode: session.token,
            userId: session.userId,
            phoneSystem: session.phoneSystem,
            accountId,
        }).then((res) => {
            if (res && res.errorCode == 0 && Array.isArray(res.data) && res.data[0]) {
                const device = res.data[0];
                const apiDeviceId = device.deviceId != null ? device.deviceId : device.DevID;
                if (billDeviceId != null && billDeviceId !== '' && apiDeviceId != null && apiDeviceId !== ''
                    && String(billDeviceId) !== String(apiDeviceId)) {
                    Toast.show({ content: '设备信息已更改，请更换其他设备' });
                    return;
                }
                const phoneSys = String(session.phoneSystem || '').toLowerCase();
                const isAlipay = /Alipay/i.test(navigator.userAgent) || phoneSys === 'alipay' || phoneSys.includes('alipay');
                const isWechat = /MicroMessenger/i.test(navigator.userAgent)
                    || phoneSys.includes('wechat') || phoneSys.includes('micromessenger');
                // 微信/支付宝：整包设备（含 onlineStatusId）；App：约定精简字段
                const devList = (isAlipay || isWechat)
                    ? this.buildAlipayUseDevicePayload(device, accountId, projectId, billSn)
                    : this.buildAppUseDevicePayload(device, billdetail, accountId, projectId, billSn);
                console.log('[useDevice] payload=', devList);
                this.jumpUseDevicePage(devList);
                return;
            }
            if (res && res.errorCode == 0) {
                Toast.show({ content: '设备信息已更改，请更换其他设备' });
            } else {
                Toast.show({ content: (res && res.errorMessage) || '获取设备信息失败' });
            }
        }).catch(() => {
            Toast.show({ content: '获取设备信息失败' });
        });
    }
    jumpUseDevicePage = (devList) => {
        const query = encodeURIComponent(JSON.stringify(devList));
        var ua = navigator.userAgent.toLowerCase();

        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            // 与微信小程序一致：在线(1)=4G goShowerSnV3；非在线=蓝牙 GoShowerV3；入参 devList
            const status = devList.onlineStatusId != null ? Number(devList.onlineStatusId)
                : (devList.isOnline != null ? Number(devList.isOnline) : 1);
            const isOnline = status === 1;
            const path = isOnline
                ? '/pages/goShowerSnV3/goShowerSnV3'
                : '/pages/GoShowerV3/GoShowerV3';
            wx.miniProgram.navigateTo({
                url: `${path}?devList=${query}`,
                fail: () => Toast.show({ content: '跳转下单页失败' }),
            });
            return;
        }
        if (/Alipay/i.test(navigator.userAgent)) {
            this.navigateAlipayUseDevice(devList, query);
            return;
        }
        if (browser.versions.android) {
            try {
                if (window.android && typeof window.android.onUseDevice === 'function') {
                    window.android.onUseDevice(JSON.stringify(devList));
                    return;
                }
                Toast.show({ content: '跳转下单页失败，请升级 App 后重试' });
            } catch (e) {
                Toast.show({ content: '跳转下单页失败，请升级 App 后重试' });
            }
            return;
        }
        if (browser.versions.ios) {
            try {
                window.webkit.messageHandlers.useDeviceClick.postMessage(JSON.stringify(devList));
            } catch (e) {
                Toast.show({ content: '跳转下单页失败，请升级 App 后重试' });
            }
            return;
        }
        Toast.show({ content: '当前环境暂不支持跳转下单页' });
    }
    clickHandlerSkip = () => {
        var ua = navigator.userAgent.toLowerCase();

        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    console.log('在wx小程序内');
                    let data = GetRequest();
                    wx.miniProgram.navigateTo({
                        url: '../../package_customerService/pages/orderComplainFillIn/orderComplainFillIn?info=' + JSON.stringify(this.state.complainData)
                    })
                    return;
                }
            })
            return;
        }

        if (/Alipay/i.test(navigator.userAgent)) {
            //支付宝申诉双通道：勿动 慎改慎改！勿动 慎改慎改！勿动 慎改慎改！
            this.navigateAlipayOrderAppealCompat();
            return;
        }

        if (browser.versions.android) {
            window.android.onOrderComplain();
            return;
        }
        if (browser.versions.ios) {
            window.webkit.messageHandlers.orderAppealClick.postMessage(' ')
            return;
        }
    }
    // 支付宝申诉双通道：MiniProgram UA / getEnv 才走容器；openURL 外开继续 alipays://
    navigateAlipayOrderAppealCompat = () => {
        const complainData = this.state.complainData;
        if (!complainData) {
            Toast.show({ content: '申诉信息缺失，请稍后重试' });
            return;
        }

        const openByScheme = () => {
            window.location.href = "alipays://platformapi/startapp?appId=2018090661238647&page=pages/order-appeal/order-appeal&query=appealInfo="
                + JSON.stringify(complainData);
        };

        const openInWebView = () => {
            const targetUrl = '/pages/order-appeal/order-appeal?appealInfo='
                + encodeURIComponent(JSON.stringify(complainData));

            const tryNav = (method, onFail) => {
                if (!window.my || typeof window.my[method] !== 'function') return false;
                try {
                    window.my[method]({
                        url: targetUrl,
                        fail: (err) => {
                            console.warn(`my.${method} order-appeal failed`, err);
                            if (typeof onFail === 'function') onFail();
                        },
                    });
                    return true;
                } catch (e) {
                    return false;
                }
            };

            const tryPostMessage = () => {
                if (!window.my || typeof window.my.postMessage !== 'function') return false;
                try {
                    window.my.postMessage({ action: 'orderAppeal', appealInfo: complainData });
                    if (typeof window.my.navigateBack === 'function') {
                        setTimeout(() => {
                            try { window.my.navigateBack(); } catch (e) { /* ignore */ }
                        }, 50);
                    }
                    return true;
                } catch (e) {
                    return false;
                }
            };

            const failOnly = () => {
                Toast.show({ content: '跳转申诉页失败，请升级小程序后重试' });
            };

            if (tryNav('navigateTo', () => {
                if (tryNav('redirectTo', () => {
                    if (tryPostMessage()) return;
                    failOnly();
                })) return;
                if (tryPostMessage()) return;
                failOnly();
            })) return;
            if (tryNav('redirectTo', () => {
                if (tryPostMessage()) return;
                failOnly();
            })) return;
            if (tryPostMessage()) return;
            failOnly();
        };

        // 无 MiniProgram UA → 外开（你这条测试链接），直接 scheme，与改坏前一致
        if (!this.isAlipayMiniProgramUa()) {
            openByScheme();
            return;
        }

        const run = (inMp) => {
            if (this.shouldUseAlipayMpNav(inMp)) openInWebView();
            else openByScheme();
        };

        if (window.my && typeof window.my.getEnv === 'function') {
            let settled = false;
            const finish = (flag) => {
                if (settled) return;
                settled = true;
                run(flag);
            };
            try {
                window.my.getEnv((res) => finish(!!(res && res.miniprogram)));
                setTimeout(() => finish(true), 300);
                return;
            } catch (e) {
                run(true);
                return;
            }
        }
        this.loadAlipayMiniProgramBridge().then(() => run(true));
    }
    render() {
        const { billdetail, isGzh, canComplainData, orderAppealSwitch } = this.state;
        const { useType, tradeSettlement, runStatus, deviceDescription, consumeMoney, orderNo, consumeSceneType, consumeDate, uploadDate,
            waterUsageShow, waterTemperatureShow, modeInfo, thirdTradeMoney, tradeNo, settlementTime, deductType, monthConsumeMoney, walletConsumeMoney,
            preDeductMoney, consumeMoneyGiven, consumeMoneyReal, canComplain, waterUsageShowSwitch, waterTemperatureShowSwitch, orderNumber,
            reduceMoney, reduceRemark, originalConsumeMoney, comboType, bigTypeId, rightLiquidInfo, leftLiquidInfo, orderOfflineTag,
            channelType, compensateStatus, compensateMoney, repeatDownRateStatus, showRepeateOpenButton, consumeChannel
        } = billdetail;
        // 需求三：已重新启动标识，仅洗衣机(bigTypeId==6)展示；兼容管理端 repeatDownRateStatus 与新字段 showRepeateOpenButton
        const isRepeatOpen = (bigTypeId == 6||bigTypeId == 7) && (repeatDownRateStatus == 1 || showRepeateOpenButton == 1);
        return (

            <div className='billdetail_container'>
                {this.renderModal()}
                {this.renderModalErr()}
                <div className='billdetail_top'>
                    <div className='status' style={{ color: tradeSettlement == 0 && runStatus == 1 ? '#FC5A5A' : '#5ABDFC' }}>
                        {tradeSettlement == 0 && <span>未支付</span>}
                        {tradeSettlement == 1 && <span>已支付</span>},
                        {runStatus == 0 && <span>未完成</span>}
                        {runStatus == 1 && <span>已完成</span>}
                        <span style={{ visibility: runStatus == 0 ? 'visible' : 'hidden' }} className='doubt' onClick={this.showTip}>使用完还是未完成？</span>

                    </div>
                    <div className='address'>{deviceDescription}</div>
                    {/* 需求一：多路设备展示实际使用路数；需求三：已重新启动标识 */}
                    {(channelType != null && channelType != 0) || isRepeatOpen ? <div className='tags'>
                        {channelType != null && channelType != 0 ? <span className='bgbd'>{channelType}路</span> : null}
                        {isRepeatOpen ? <span className='bgbd'>已重新启动</span> : null}
                    </div> : null}
                    {tradeSettlement == 0 && runStatus == 0 && useType == 0 ? '' : <div className='amount'>{consumeMoney}
                        <span className='unit'>元</span>
                    </div>}
                </div>
                <div className='billdetail_bottom'>
                    <div className='item'>
                        <div className='title'>订单金额：</div>
                        <div className='contents'><span>{originalConsumeMoney}元</span></div>
                    </div>
                    {comboType != 0 && <div className='item' >
                        <div className='title'>优惠金额：</div>
                        <div className='contents'>
                            <span>{reduceMoney}元</span><span>({reduceRemark})</span>
                        </div>
                    </div>}
                    <div className='item'>
                        <div className='title'>支付金额：</div>
                        <div className='contents a-flex'>
                            {tradeSettlement == 0 && runStatus == 0 && useType == 0 ? '' : <span className='amount'>{consumeMoney}元 </span>}
                            {/* 需求二：错扣补款标识 */}
                            {compensateStatus == 1 ? <span className='compensateStatus'>已补款{compensateMoney}元</span> : null}
                        </div>
                    </div>
                    <div className='border'></div>
                    <div className='item'>
                        <div className='title'>订单号：</div>
                        <div className='contents'><span>{orderNumber}</span></div>
                        {orderOfflineTag == 1 ? <div className='offline'>延时结算订单</div> : null}
                    </div>
                    <div className='item'>
                        <div className='title'>消费类型：</div>
                        <div className='contents'>
                            {consumeSceneType == 0 && <span>手机消费</span>}
                            {consumeSceneType == 2 && <span>卡片消费</span>}
                            {consumeSceneType == 3 && <span>密码消费</span>}
                        </div>
                    </div>
                    <div className='item'>
                        <div className='title'>使用时间：</div>
                        <div className='contents'><span>{consumeDate}</span></div>
                    </div>
                    {useType == 1 || bigTypeId == 18 ? '' : <div className='item'>
                        <div className='title'>完成时间：</div>
                        <div className='contents'><span>{uploadDate}</span></div>
                    </div>}
                    <div className='item' style={{ display: useType == 1 ? 'flex' : 'none' }}>
                        <div className='title'>模式：</div>
                        {bigTypeId == 16 ? <div className='contents'>
                            {leftLiquidInfo ? <div>{leftLiquidInfo}</div> : ''}
                            {rightLiquidInfo ? <div>{rightLiquidInfo}</div> : ''}

                        </div> : <div className='contents'>
                            <span>{modeInfo}</span>
                        </div>}
                    </div>

                    {tradeSettlement == 0 && runStatus == 0 ? '' : bigTypeId == 18 ? '' : <div className='item' style={{ display: ((waterTemperatureShow != null && waterTemperatureShow != -1) || (waterUsageShow != null && waterUsageShow != -1)) ? 'flex' : 'none' }}>
                        <div className='title'>用水详情：</div>
                        <div className='contents'>
                            {waterUsageShow != null && waterUsageShow != -1 ? <span style={{ marginRight: '0.24rem' }}>用水量:{waterUsageShow != 'null' ? waterUsageShow + "L" : "--"}</span> : ''}
                            {waterTemperatureShow != null && waterTemperatureShow != -1 ? <span>用水水温:{waterTemperatureShow != 'null' ? waterTemperatureShow + "°C" : '--'}</span> : ''}
                        </div>
                    </div>}
                    {preDeductMoney == 0 || bigTypeId == 18 ? '' : useType == 0 ? <div className='item'>
                        <div className='title'>钱包预扣费：</div>
                        <div className='contents'><span>{preDeductMoney}元{runStatus == 0 ? '（未结算）' : '（已结算）'}</span></div>
                    </div> : ''}
                    {deductType == 10 ? ''
                        : walletConsumeMoney != null && walletConsumeMoney != 0 ? <div className='item'>
                            <div className='title'>钱包支付：</div>
                            <div className='contents'>
                                <span>{walletConsumeMoney}元</span>
                                （<span>{`现金余额支付:${consumeMoneyReal}元`}</span>
                                <span>{`，赠送余额支付:${consumeMoneyGiven}元`}</span>）
                            </div>
                        </div> : ''}
                    {walletConsumeMoney == 0 && tradeSettlement == 0 && deductType == 6 ? <div className='item'>
                        <div className='title'>钱包支付：</div>
                        <div className='contents'>
                            <span>{thirdTradeMoney}元（未支付）</span>
                        </div>
                    </div> : ''}
                    {tradeSettlement == 0 && runStatus == 0 ? '' : deductType == 3 || deductType == 5 || deductType == 7 ? <><div className='item'>
                        {deductType == 3 ? <div className='title'>支付宝代扣：</div> : ''}
                        {deductType == 5 ? <div className='title'>微信代扣：</div> : ''}
                        {deductType == 7 ? <div className='title'>一卡通代扣：</div> : ''}
                        <div className='contents'><span>{thirdTradeMoney}元{tradeSettlement == 0 ? '（未支付）' : '（已支付）'}</span></div>
                    </div>
                        {tradeSettlement == 1 && tradeNo ? <div className='item'>
                            <div className='title'>代扣支付单号：</div>
                            <div className='contents'><span>{tradeNo}</span></div>
                        </div> : ''}
                        {tradeSettlement == 1 && settlementTime ? <div className='item'>
                            <div className='title'>代扣支付时间：</div>
                            <div className='contents'><span>{settlementTime}</span></div>
                        </div> : ''}
                    </> : ''}
                    {(() => {
                        // 需求四：仅洗澡/饮水预扣设备展示「使用设备」；集中器澡堂(consumeChannel=4)不展示
                        const showUseDevice = !isGzh
                            && USE_DEVICE_BIG_TYPE_IDS.includes(Number(bigTypeId))
                            && Number(consumeChannel) !== CONSUME_CHANNEL_BATHHOUSE
                            && this.canShowUseDeviceButton(this.state.phoneSystem);
                        const showPay = !isGzh && tradeSettlement == 0 && thirdTradeMoney > 0;
                        if (!showUseDevice && !showPay) return null;
                        return (
                            <div className='btnBox'>
                                {showUseDevice ? <button className='btn-plain' shape='rounded' onClick={this.useDevice}>使用设备</button> : null}
                                {showPay ? <button className='btn' shape='rounded' color='primary' onClick={this.gotoPay}>去支付</button> : null}
                            </div>
                        );
                    })()}
                </div>
                {/* 家长端无申诉功能；用户端需 orderAppealSwitch 开启 */}
                {!isGzh && !!orderAppealSwitch ? <div className='complaint' style={{ color: canComplain == 1 || canComplainData == 1 ? "#ccc" : "" }} onClick={this.complaint}>对此订单发起申诉</div> : null}
            </div>
        )
    }
}
export default Billdetail;

